/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { NotificationType } from './NotificationType';
import {
    NotificationTypeFromJSON,
    NotificationTypeFromJSONTyped,
    NotificationTypeToJSON,
    NotificationTypeToJSONTyped,
} from './NotificationType';
import type { WinningCriteria } from './WinningCriteria';
import {
    WinningCriteriaFromJSON,
    WinningCriteriaFromJSONTyped,
    WinningCriteriaToJSON,
    WinningCriteriaToJSONTyped,
} from './WinningCriteria';

/**
 * 
 * @export
 * @interface NotificationMetadata
 */
export interface NotificationMetadata {
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationMetadata
     */
    notificationType: NotificationType;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    nftUri?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    mintDate?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    guildId?: string;
    /**
     * 
     * @type {WinningCriteria}
     * @memberof NotificationMetadata
     */
    winningCriteria?: WinningCriteria;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    winnerMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    challengeName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    rewardName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    challengeEndDate?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationMetadata
     */
    amount?: number;
    /**
     * 
     * @type {RewardType}
     * @memberof NotificationMetadata
     */
    rewardType?: RewardType;
}



/**
 * Check if a given object implements the NotificationMetadata interface.
 */
export function instanceOfNotificationMetadata(value: object): value is NotificationMetadata {
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    return true;
}

export function NotificationMetadataFromJSON(json: any): NotificationMetadata {
    return NotificationMetadataFromJSONTyped(json, false);
}

export function NotificationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'notificationType': NotificationTypeFromJSON(json['notificationType']),
        'nftUri': json['nftUri'] == null ? undefined : json['nftUri'],
        'mintDate': json['mintDate'] == null ? undefined : json['mintDate'],
        'description': json['description'] == null ? undefined : json['description'],
        'guildId': json['guildId'] == null ? undefined : json['guildId'],
        'winningCriteria': json['winningCriteria'] == null ? undefined : WinningCriteriaFromJSON(json['winningCriteria']),
        'winnerMessage': json['winnerMessage'] == null ? undefined : json['winnerMessage'],
        'challengeName': json['challengeName'] == null ? undefined : json['challengeName'],
        'rewardName': json['rewardName'] == null ? undefined : json['rewardName'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'challengeEndDate': json['challengeEndDate'] == null ? undefined : json['challengeEndDate'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'rewardType': json['rewardType'] == null ? undefined : RewardTypeFromJSON(json['rewardType']),
    };
}

export function NotificationMetadataToJSON(json: any): NotificationMetadata {
    return NotificationMetadataToJSONTyped(json, false);
}

export function NotificationMetadataToJSONTyped(value?: NotificationMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notificationType': NotificationTypeToJSON(value['notificationType']),
        'nftUri': value['nftUri'],
        'mintDate': value['mintDate'],
        'description': value['description'],
        'guildId': value['guildId'],
        'winningCriteria': WinningCriteriaToJSON(value['winningCriteria']),
        'winnerMessage': value['winnerMessage'],
        'challengeName': value['challengeName'],
        'rewardName': value['rewardName'],
        'assetId': value['assetId'],
        'challengeEndDate': value['challengeEndDate'],
        'amount': value['amount'],
        'rewardType': RewardTypeToJSON(value['rewardType']),
    };
}

